import './App.css';
// CSS for visualization
import '@joint/plus/joint-plus.css';
import 'react-toastify/dist/ReactToastify.css';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import router from './routes';
import { useQueryClient } from '@tanstack/react-query';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function App() {
  const queryClient = useQueryClient();
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <RouterProvider router={router(queryClient)} />
        <ToastContainer />
      </LocalizationProvider>
    </>
  );
}

export default App;
